"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parse(value) {
    var arr = [];
    var lines = value.replace(/\r?\n$/, '').split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
        var header = lines[i];
        var indexOf = header.indexOf(':');
        var name = header.substr(0, indexOf).trim();
        var value_1 = header.substr(indexOf + 1).trim();
        arr.push(name, value_1);
    }
    return array(arr);
}
exports.parse = parse;
function http(response) {
    if (response.rawHeaders) {
        return array(response.rawHeaders);
    }
    var headers = {};
    Object.keys(response.headers).forEach(function (key) {
        var value = response.headers[key];
        if (value.length === 1) {
            headers[key] = value[0];
        }
        else {
            headers[key] = value;
        }
    });
    return headers;
}
exports.http = http;
function array(values) {
    var casing = {};
    var headers = {};
    for (var i = 0; i < values.length; i = i + 2) {
        var name = values[i];
        var lower = name.toLowerCase();
        var oldName = casing[lower];
        var value = values[i + 1];
        if (!headers.hasOwnProperty(oldName)) {
            headers[name] = value;
        }
        else {
            if (name !== oldName) {
                headers[name] = headers[oldName];
                delete headers[oldName];
            }
            if (typeof headers[name] === 'string') {
                headers[name] = [headers[name], value];
            }
            else {
                headers[name].push(value);
            }
        }
        casing[lower] = name;
    }
    return headers;
}
exports.array = array;
//# sourceMappingURL=index.js.map